import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import '@fortawesome/fontawesome-free/css/all.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import {i18n} from "@/plugins/i18n";

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#5A81F9',
                secondary: '#9AB8F4',
                strongSecondary: '#00496F',
                tertiary: '#707070'
            }
        }
    },
    icons: {
        iconfont: 'mdiSvg' // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
    },
    lang: {
        t: (key, ...params) => i18n.t(key, params),
    }
});
